import React, {useState, useEffect, useContext, useRef} from "react";
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {useHistory} from 'react-router-dom';
import {functions} from "../../constants/common-functions";
import {store} from '../../context/store';
import {NO_STRINGIFY} from "../../constants/general-constants";
import {JWT} from "../../constants/local-storage";
import CircularProgress from '@material-ui/core/CircularProgress';
import {YES_NO_OPTIONS} from "../../constants/general-constants";
import {STRINGIFY} from "../../constants/general-constants";
import PhotoTourZipPanel from '../administration/components/PhotoTourZipPanel';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationPhotoToursZip(){
	const history = useHistory(); 
	const [displayProgress, setDisplayProgress] = useState("none");
	const [photoTourZips, setPhotoTourZips] = useState([]);
	const [topButtonLabel, setTopButtonLabel] = useState("View All");
	
	useEffect(() => {
		loadData();
	}, [topButtonLabel]);
	
	
	const loadData = () => {
		if(topButtonLabel === "View All"){
			loadDataOnlyIncompleted();
		}
		else{
			loadDataAll();
		}
	};
	
	const loadDataOnlyIncompleted = () => {
		functions.getArrayFromAjax("/resolution/phototourzipdisplays?showOnlyIncomplete=true", null, populatePhotoTourZips);
	};
	
	const loadDataAll = () => {
		functions.getArrayFromAjax("/resolution/phototourzipdisplays?showOnlyIncomplete=false", null, populatePhotoTourZips);
	};
	
	const populatePhotoTourZips = (zips) => {
		setPhotoTourZips(zips);
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const mainTitle = {
		display:"flex",
		marginLeft:"20px",
		marginRight:"20px",
		height:"60px",
		fontSize:"21px",
		alignItems:"center",
		justifyContent:"space-between"	
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%",
		flexDirection:"column"
	};
	
	const blueButton = {
		display:"flex",
		width:"140px",
		height:"30px",
		alignItems:"center",
		color:"white",
		backgroundColor:DEFAULT_BLUE,
		cursor:"pointer",
		justifyContent:"space-around",
		borderRadius:"4px",
		fontSize:"12px"
	};
	
	const zipList = photoTourZips.map((item, index)=> 
		<PhotoTourZipPanel
			id={item.id}
			photoTourZip={item}
			reloadFunction={loadData}
		/>
	);
	
	const changeView = () => {
		if(topButtonLabel === "View All"){
			setTopButtonLabel("View Non-Completed");
		}
		else{
			setTopButtonLabel("View All");
		}
	};
	
	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
					<div style={mainTitle}>
						Photo Tour Zip File Uploads
						<div style={blueButton} onClick={changeView}>
							{topButtonLabel}
						</div>
					</div>
					<div style={contentPanel}>
						{zipList}
					</div>
			</div>
	
	);
}